<template>
    <div class="card-container">
        <el-page-header @back="$router.go(-1)" :content="`策略配置--${tatInfo.tatName}`" class="commonTitle"></el-page-header>
        <common-top-form @openAddDialog="openAddDialog" :selectShow="false"></common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="type" label="类型" :formatter="formatterTableType" min-width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="moneyRange" label="N元以下" :formatter="formatterTableNumberYuan" min-width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="money" label="扣M元" :formatter="formatterTableNumberYuan" min-width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" :formatter="formatterTableData" min-width="160"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" :formatter="formatterTableData" min-width="160"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="openAddDialog(scope.row)">修改</el-button>
                    <el-button type="text" @click="handleDel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel" :rules="dialogRules"
                     :dialogService="dialogService" :submitData="dialogData" @success="dialogSuccess"
                     @close="dialogClose" labelWidth="100px">
            <div class="line-bottom">
                <el-form-item label="类型" prop="type">
                    <el-select v-model="dialogModel.type">
                        <el-option
                            v-for="item in types"
                            :key="item.dictKey"
                            :label="item.dictValue"
                            :value="item.dictKey">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="line-bottom">
                <el-form-item label="N元以下" prop="moneyRange">
                    <el-input-number v-model="dialogModel.moneyRange" :precision="2" :step="0.1" :controls="false"
                                     :min="0" controls-position="right"></el-input-number>
                    <span class="unit">元</span>
                </el-form-item>
                <el-form-item label="扣M元" prop="money">
                    <el-input-number v-model="dialogModel.money" :precision="2" :step="0.1" :controls="false"
                                     :min="0" controls-position="right"></el-input-number>
                    <span class="unit">元</span>
                </el-form-item>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import TimeRange from 'service/constant/TimeRange'
    import FormDialog from '../../dialog/FormDialog'
    import FinanceService from 'service/FinanceService'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "taxlog",
        data() {
            return {
                formModel: {
                    tatId: '',
                },
                tableData: [],
                submitService: FinanceService.tatTaxMemParameterList,
                page: [],
                isPage: false,
                countInfo: {},
                orderTypes: [],
                formDialogTitle: '',
                dialogService: null,
                infoId: '',
                dialogModel: {
                    moneyRange: '',
                    money: '',
                    type: '',
                },
                dialogRules:{
                    type: [{
                        required: true,
                        message: '请选择类型'
                    }],
                },
                types:[],
                getTatSimpleId:'',
                tatInfo:{},
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components: {
            CommonTopForm,
            CommonTable,
            SelectOrgans,
            FormDialog
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.tatInfo = JSON.parse(this.$route.params.item);
            this.getList();

            this.getTypeNames('个人账户类型', (res) => {
                this.types = res
            });
        },
        beforeRouteEnter(to, from, next){
            next(vm => {
                if (vm.roleYuan.indexOf(vm.userInfo.userName) < 0) {
                    vm.showWarming('您暂无该权限');
                    vm.$router.back(-1);
                }
            })
        },
        computed: {
            dialogData() {
                return {
                    tatSimpleId: this.tatInfo.tatSimpleId,
                    money: this.dialogModel.money,
                    moneyRange: this.dialogModel.moneyRange,
                    type: this.dialogModel.type,
                    id: this.infoId
                }
            },
            ...mapGetters(['serverType', 'tatId', 'userId', 'userInfo']),
        },
        methods: {
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, {
                    tatSimpleId: this.tatInfo.tatSimpleId,
                }, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                const result = data.contents;
                this.tableData = result.rows;
                this.page.currentPage = result.current;
                this.page.total = result.total;
                this.page.pageSize = result.size;
            },
            openAddDialog(item) {
                this.$refs.formDialog.open();
                this.infoId = item ? item.id : '';
                this.getTatSimpleId = '';
                if (this.infoId) {
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.dialogModel.type = this.dialogModel.type.toString();
                    this.getTatSimpleId = this.dialogModel.tatId;
                }
                this.formDialogTitle = this.infoId ? '修改' : '添加';
                this.dialogService = this.infoId ? FinanceService.tatTaxMemParameterEdit : FinanceService.tatTaxMemParameterAdd;
            },
            dialogSuccess(data) {
                this.doCheck(data, data => {
                    this.showSuccess(data.respMsg);
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                })
            },
            formatterTableType(row, column, cellValue, index){
                let value = '--';
                this.types.forEach(item => {
                    if (cellValue == item.dictKey) {
                        value = item.dictValue
                    }
                });

                return value
            },
            dialogClose() {
                this.dialogModel = {
                    moneyRange: '',
                    money: '',
                    type: '',
                }
            },
            handleDel(id){
                this.showConfirm('确定删除该配置？').then(()=>{
                    this.doDel(id)
                }).catch(()=>{});
            },
            doDel(id){
                this.doLoad(FinanceService.tatTaxMemParameterDel, {
                    id: id
                }, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.respMsg)
                        this.getList();
                    });
                }, '信息获取失败')
            },
        }
    }
</script>

<style scoped>
    .unit {
        margin-left: 15px;
    }

    .line-bottom{
        border-bottom: 1px dashed #e6e6e6;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/TaxMemConfig.vue